import { render, staticRenderFns } from "./BankCardManage.vue?vue&type=template&id=393aeafd&scoped=true"
import script from "./BankCardManage.vue?vue&type=script&lang=js"
export * from "./BankCardManage.vue?vue&type=script&lang=js"
import style0 from "./BankCardManage.vue?vue&type=style&index=0&id=393aeafd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393aeafd",
  null
  
)

export default component.exports